import { RiPhoneFill } from 'react-icons/ri';

export const teamData = [
  {
    name:'Adam Smith',
    description: 'Main Family Doctor',
    icon: <RiPhoneFill />,
    imageUrl: '../../img/doctor1.jpg',
    phone: '(123) 123-7899',
  },
  {
    name:'Edward Paul',
    description: 'Family Doctor',
    icon: <RiPhoneFill />,
    imageUrl: '../../img/doctor2.jpg',
    phone: '(123) 123-7899',
  },
  {
    name:'Elizabeth Rouz',
    description: 'Family Doctor',
    icon: <RiPhoneFill />,
    imageUrl: '../../img/doctor3.jpg',
    phone: '(123) 123-7899',
  }
]